import { Breadcrumbs, Typography, Link } from "@mui/material";
import { useObrasGestaoServicosViewModel } from "../../viewModels/obras_gestao_servicos_view_model";
import { IncorporacaoBlocoLista } from "./components/incorporacao_bloco_lista";
import { Header } from "./components/header";
import { ObrasTopHeader } from "../../components/obras_top_header";
import { ObrasTopBar } from "../../components/obras_top_bar";
import { ObrasReportModals } from "../../components/obras_report_modals";
import { Link as LinkTo } from "react-router";

import AlertError from "../../../../../common/components/alert_error";
import ProgressBar from "../../../../../common/components/progress_bar";

/**
 * ObrasGestaoServicos
 */

export const ObrasGestaoServicos = () => {
  const viewModel = useObrasGestaoServicosViewModel();
  return (
    <>
      {/**
        * ObrasTopBar
        */}

      <ObrasTopBar
        obrasReportState={viewModel.obrasReportState}
        state={viewModel.obrasTopHeaderState}
        selectedObra={viewModel.selectedObraHeaderInfo}
        onBack={viewModel.handleBack}
      />

      <div className="flex w-full gap-2 flex-col py-2 px-4 mb-24">
        <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
          <Link underline="hover" color="inherit">
            Obras
          </Link>
          <Link underline="hover" color="inherit" component="span">
            <LinkTo to="/Obras_lista">Lista de Obras</LinkTo>
          </Link>
          <Typography className="text-primary-green">
            Gestão de serviços
          </Typography>
        </Breadcrumbs>

        {/**
        * ObrasTopHeader
        */}

        <ObrasTopHeader
          title="Gestão de serviços"
          selectedObra={viewModel.selectedObraHeaderInfo}
          onReload={viewModel.handleReload}
        />

        {
          viewModel.errorMessage !== undefined
            ? (
              <div className="w-full">
                <AlertError
                  messageErro={viewModel.errorMessage}
                  onTryAgain={viewModel.handleReload} />
              </div>
            ) : (
              <>
                <Header
                  empreendimentos={viewModel.dropdown.empreendimentosDropDown}
                  centrosCusto={viewModel.dropdown.centroCustosDropDown}
                  blocos={viewModel.dropdown.incorporacaoBlocosDropDown}
                  empreendimento={viewModel.selectedEmpreendimento}
                  selectedEmpreendimento={viewModel.selectedEmpreendimentoDropDown}
                  selectedCentroCusto={viewModel.selectedCentroCustoDropDown}
                  selectedBlocos={viewModel.selectedIncorporacaoBlocoDropDown}
                  onBlocosChange={viewModel.handleIncorporacaoBlocoDropDownChange}
                />

                {
                  viewModel.loading ? (
                    <>
                      <div className="w-full  flex-col p-4 rounded-lg gap-2 border border-stone-500 flex justify-center items-center bg-[#FFFFFF] dark:bg-[#393939]">
                        <div className="w-full">
                          <ProgressBar />
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      {
                        viewModel.selectedIncorporacaoBlocoLista &&
                        <div className='w-full flex flex-col justify-center itens-center bg-light-mode-2 dark:bg-dark-mode-2  border-[1px] border-border-light-mode dark:border-border-dark-mode overflow-x-hidden rounded-[4px]'>
                          <div className="max-w-full w-auto flex items-center overflow-x-auto p-4">
                            <IncorporacaoBlocoLista
                              incorporacaoBlocoLista={viewModel.selectedIncorporacaoBlocoLista} />
                          </div>
                        </div>
                      }
                    </>
                  )
                }

              </>
            )
        }
      </div>

      {/**
        * Relatorios obras.
        */}

      <ObrasReportModals
        state={viewModel.obrasReportState}
      />
    </>
  );
}
